import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  button: {
    margin: '5px 5px'
  }
};

const enhance = compose();

const button = enhance(
  ({
    classes,
    onClickAction,
    enabled = true,
    fullWidth = false,
    btnText = '変更'
  }) => {
    return (
      <Button
        variant="contained"
        color="primary"
        className={classes.button}
        onClick={onClickAction}
        disabled={!enabled}
        fullWidth={fullWidth}
      >
        {btnText}
      </Button>
    );
  }
);

export default withRouter(withStyles(styles)(button));
